import { storeToRefs } from 'pinia'
import { useToastStore } from '../stores/toastStore'
export function useToast() {
  const store = useToastStore()
  const { items } = storeToRefs(store)
  return {
    items,
    show: store.show,
    dismiss: store.dismiss,
    clearAll: store.clearAll,
    success: store.success,
    error: store.error,
    info: store.info,
    warning: store.warning,
  }
}
